import React, { useRef, useState } from 'react'
import { Button, Divider, Form, Input, Modal, Select, Table, message } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import services from '../../Services'
import Services from '../../Services';
import { useEffect } from 'react'
import moment from 'moment'
import { showText } from '../../helpers/textValidation'
import PgDynamicTable from '../../Components/TableComponents/PgDynamicTable'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import { EyeOutlined } from '@ant-design/icons'
import { Link, useHistory } from "react-router-dom";
const { payroll } = services
const PendingPayrollTickets = () => {
    const history = useHistory()

    const {
        payroll
    } = Services;
    const [form_1] = Form.useForm()
    const [form_2] = Form.useForm()
    const [edit, setEdit] = useState(false)
    const [tickets, setTickets] = useState({})
    const [modal, setModal] = useState({ approval: false, id: null, rejection: false })
    const [pagination, setPagination] = useState({
        limit: 10,
        offSet: 0,
    })

    const PendingPayrollTickets = async () => {

        const response = await payroll.fetchPendingPayrollTickets(pagination)
        if (response?.httpStatus != 200) return
        setTickets(response?.data)

    }

    useEffect(() => {
        PendingPayrollTickets()
    }, [pagination])

    let table = {
        header: [
            "Tck ID",
            "Name",
            "Ticket/Alert",
            "Open Date",
            "Category",
            "Approval Status",
            "Actions",
        ],
        rows: tickets?.rows?.map((col, index) => [
            showText(col?.id),
            showText(col?.FEmployee ? col?.FEmployee?.firstName + " " + col?.FEmployee?.lastName : col?.employeeName),
            showText(col?.isAlert ? 'Alert' : 'Ticket'),
            col?.OpenDate ? moment(col?.OpenDate)?.utc()?.format("MM-DD-YYYY") : "N/A",
            <p style={{ width: "140px", overflow: 'hidden', whiteSpace: "wrap" }}>{col?.TicketCategory?.name ? col?.TicketCategory?.name : showText(col?.TicketCategoryText)}</p>,
            showText(col?.Status),
            // <Button
            //     onClick={() => history.push('/pending-payroll-ticket-detail', { id: col?.id })}
            // >
            //     <EyeOutlined /> View
            // </Button>
            <div style={{ display: 'flex', justifyContent: 'start' }}>
                <Button
                    onClick={() => history.push('/pending-payroll-ticket-detail', { id: col?.id })}
                    className={"ViewIconNew"}
                >
                    <p></p>
                </Button>
            </div >


        ])
    }

    const submitAPI = async (values) => {
        const response = await payroll.approveTicket(modal?.id, values)
        setModal({ approval: false, rejection: false, id: null })
        form_1.resetFields()
        form_2.resetFields()
        await PendingPayrollTickets()
    }

    const ModalHandler = (obj) => setModal(prev => ({ ...prev, ...obj }))

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Payroll Tickets - Pending Approval</Grid>
                <div style={{marginTop:'20px'}}>
                    <PgDynamicTable
                        tableData={table}
                        setPagination={setPagination}
                        pagination={pagination}
                        edit={edit}
                        count={tickets?.count} />
                </div>
                <Modal
                    title="Approval"
                    open={modal?.approval}
                    footer={false}
                    onCancel={() => ModalHandler({ approval: false })}>
                    <Form form={form_1} onFinish={(values) => submitAPI({ ...values, approved: true })}>
                        <Form.Item
                            name="RejectApproveNotes"
                            label="Notes"
                            rules={[
                                {
                                    required: true,
                                    message: 'Notes are required!'
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button htmlType='submit'>Submit</Button>
                        </div>
                    </Form>
                </Modal>
                <Modal
                    title="Rejection"
                    open={modal?.rejection}
                    footer={false}
                    onCancel={() => ModalHandler({ rejection: false })}>
                    <Form form={form_2} onFinish={(values) => submitAPI({ ...values, approved: false })}>
                        <Form.Item
                            name="RejectApproveNotes"
                            label="Notes"
                            rules={[
                                {
                                    required: true,
                                    message: 'Notes are required!'
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button htmlType='submit'>Submit</Button>
                        </div>
                    </Form>
                </Modal>
            </Grid>
        </PageLayout>
    )
}

export default PendingPayrollTickets